import CrudActionSetBase from './CrudActionSetBase'

export class LoadTypeActionSet extends CrudActionSetBase('loadType'){}
export default new LoadTypeActionSet()